import { DataTypeCoaching } from '@efdigital/ll-addon-data/data-types';
import type { CoachingPartnership } from '@efdigital/ll-addon-data/types/coaching/coaching-partnership';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api.ts';
import { query } from '@warp-drive/utilities/json-api';

import { sort } from '../../json-api.ts';

/**
 * Read-only: the coach-assignment records within a coaching plan, most recent
 * first. Surfaces partnership state (pending / chemistry / declined / chosen)
 * for admin oversight — it does not drive matching or selection.
 */
export function findCoachingPartnershipsByCoachingPlan(
  coachingPlanId: string,
  { reload = false }: { reload?: boolean } = {}
) {
  return query<CoachingPartnership>(
    DataTypeCoaching.CoachingPartnership,
    {
      'filter[coachingPlan.id]': coachingPlanId,
      ...sort('-modified'),
    },
    // A reassignment rewrites these rows through the admin REST API, so the
    // store's cached copy is stale afterwards — callers re-reading after one
    // must bypass the cache or they will still see the old chosen coach.
    { ...jsonApiOptions, reload }
  );
}
